<template>
  <form
    ref="htmlForm"
    :action="action"
    :method="formMethod"
    accept-charset="UTF-8"
    @submit="handleSubmit"
  >
    <input :value="csrf" type="hidden" name="_token" />
    <input v-if="shouldSpoofMethod" name="_method" type="hidden" :value="method" />
    <BaseHtmlFormUserAndAccountFields
      v-if="appendUserAndAccount"
      :account-global-id="accountGlobalId"
      :user-local-id="userLocalId"
    />
    <slot :submit="submit" />
  </form>
</template>

<script>
import BaseHtmlFormUserAndAccountFields from '@/components/BaseHtmlFormUserAndAccountFields.vue'

export default {
  components: { BaseHtmlFormUserAndAccountFields },
  props: {
    action: { type: String, default: '' },
    method: { type: String, default: 'POST' },
    appendUserAndAccount: { type: Boolean, default: false },
    accountGlobalId: { type: String, default: '' },
    userLocalId: { type: String, default: '' },
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
    }
  },
  computed: {
    shouldSpoofMethod() {
      return ['patch', 'put', 'delete'].includes(this.method.toLowerCase())
    },
    formMethod() {
      return this.shouldSpoofMethod ? 'POST' : this.method
    },
  },
  methods: {
    submit() {
      this.$refs.htmlForm.submit()
    },
    handleSubmit(event) {
      this.$emit('form-submitted', event)
    },
  },
}
</script>

<style scoped lang="scss"></style>
